import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PoliticaCookies from "../pages/politica-cookies/page";
import AvisoLegal from "../pages/aviso-legal/page";
import PoliticaPrivacidad from "../pages/politica-privacidad/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/politica-cookies",
    element: <PoliticaCookies />,
  },
  {
    path: "/aviso-legal",
    element: <AvisoLegal />,
  },
  {
    path: "/politica-privacidad",
    element: <PoliticaPrivacidad />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
